import React, { SyntheticEvent, useCallback, useEffect } from 'react';
import t from 'modules/i18n/intl';

import { Radio } from '@atlaskit/radio';
import Help from 'components/common/Help';

type TaxIdRadioProps = {
  vatResponsible: boolean | null;
  vatStatus?: 'CORPORATE' | 'INDIVIDUAL' | null;
  isTaxIdFieldEmpty: boolean;
  setBillingDetailsForm: (value) => void;
  VATRequiredMessageId: string;
  VATNotRequiredMessageId: string;
  isUkraine?: boolean;
};

const BillingDetailsTaxIdRadio = ({
  vatResponsible,
  vatStatus,
  isTaxIdFieldEmpty,
  setBillingDetailsForm,
  VATRequiredMessageId,
  VATNotRequiredMessageId,
  isUkraine,
}: TaxIdRadioProps) => {
  useEffect(() => {
    if (isTaxIdFieldEmpty && isUkraine) {
      setBillingDetailsForm((prev) => ({
        ...prev,
        vatStatus: null,
      }));
    }
  }, [isTaxIdFieldEmpty, isUkraine]);

  const radioChangeHandle = useCallback(
    (e: SyntheticEvent<HTMLInputElement>) => {
      if (isUkraine) {
        if (e.currentTarget.value === 'required') {
          setBillingDetailsForm((prev) => ({
            ...prev,
            vatStatus: 'CORPORATE',
          }));
        } else if (e.currentTarget.value === 'notRequired') {
          setBillingDetailsForm((prev) => ({
            ...prev,
            vatStatus: 'INDIVIDUAL',
          }));
        }
      } else {
        if (e.currentTarget.value === 'required') {
          setBillingDetailsForm((prev) => ({
            ...prev,
            vatResponsible: true,
          }));
        } else if (e.currentTarget.value === 'notRequired') {
          setBillingDetailsForm((prev) => ({
            ...prev,
            vatResponsible: false,
          }));
        }
      }
    },
    [isUkraine],
  );

  if (isTaxIdFieldEmpty) return null;

  const isRequiredChecked = isUkraine ? vatStatus === 'CORPORATE' : vatResponsible === true;
  const isNotRequiredChecked = isUkraine ? vatStatus === 'INDIVIDUAL' : vatResponsible === false;

  return (
    <>
      <Radio
        isChecked={isRequiredChecked}
        name="vatRequired"
        value="required"
        label={
          <>
            {t(VATRequiredMessageId)}
            {!isUkraine && <Help>{t('checkout.contact.tax-id-vat-required.help') as string}</Help>}
          </>
        }
        onChange={radioChangeHandle}
      />
      <Radio
        isChecked={isNotRequiredChecked}
        name="vatNotRequired"
        value="notRequired"
        label={t(VATNotRequiredMessageId)}
        onChange={radioChangeHandle}
      />
    </>
  );
};

export default BillingDetailsTaxIdRadio;
